export function ourSpecialtiesList() {
    const $slider = $(".our-specialties-list.has-slider");
    $slider.each(function () {
        let $this = $(this);
        $this.slick({
            slidesToScroll: 2,
            slidesToShow: 2,
            rows: 2,
            infinite: false,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        rows: 2,
                        infinite: false,
                        dots: false,
                        arrows: true,
                        appendArrows: $this.siblings(".our-specialties-list-buttons"),
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: false,
                        dots: false,
                        arrows: true,
                        appendArrows: $this.siblings(".our-specialties-list-buttons"),
                    }
                },
                {
                    breakpoint: 1799,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        infinite: false,
                        dots: false,
                        arrows: true,
                        appendArrows: $this.siblings(".our-specialties-list-buttons"),
                    }
                },
            ]
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourSpecialtiesList.js